export const getUserAvatarLabel = user => {
  return `${user?.name?.charAt(0)?.toUpperCase() || ''}${
    user?.surname?.charAt(0)?.toUpperCase() || ''
  }`;
};
